// extracted by mini-css-extract-plugin
export default {"previousVerifications":"PostVerificationExpiredBar-module__previousVerifications--r_iyE","animatedBackground":"PostVerificationExpiredBar-module__animatedBackground--ibyfO"};